import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import * as actions from './actions';
import { useActions } from 'hooks/useActions';
import { Label } from 'components/FormComponents/FormComponents';
import { Container, Wrapper, Header } from 'components/Layout/Layout';
import CurvedContainer from 'components/CurvedContainer/CurvedContainer';
import { colors } from 'global/colors';
import { Spinner } from 'components/Spinner/Spinner';

export default function GDPRConfirmationPage() {
  let { session } = useParams();

  const { deleteCandidateData } = useActions(actions);
  const { deleteResponse, error, loading } = useSelector((state) => state.GDPRConfirmationPageReducer);

  useEffect(() => {
    if (session) deleteCandidateData(session);
  }, [deleteCandidateData, session]);

  return (
    <Wrapper>
      <CurvedContainer bottom height={110} color={colors.fsDarkBlue}></CurvedContainer>
      <Container color={colors.lightGray} half column>
        <Header>GDPR Confirmation</Header>
        {loading && <Spinner />}
        {error && <Label>{error}</Label>}
        {deleteResponse && <Label>Your data has been successfully removed from Future Skill</Label>}
      </Container>
    </Wrapper>
  );
}
